"use strict";

module.exports = ['$resource', function ( $resource ) {

	let Template = $resource('/templateblocks/:id',
		{
			id: '@id'
		},
		{
			'save': {method:'POST'},
			'update': {method: 'PATCH'}
		}
	);

	var save = Template.save;

	Template.save = function ( ...args ) {
		if( args[0].id ) {
			this.update.apply(this, args);
		} else {
			save.apply(this, args);
		}
	};

	return Template;
} ];
